import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import TextFieldWithControl from '~/App/shared/components/Fields/TextFieldWithControl';
import { TextFieldProps } from '../types';
import { fieldRuleLastName } from '../fieldRules';

const LastNameField = <FormState extends FieldValues>({
  control,
  t,
  name,
  rules,
  ...props
}: TextFieldProps<FormState>) => {
  const validationRules = {
    required: {
      value: true,
      message: t(`Last name can't be blank`)
    },
    validate: fieldRuleLastName(t),
    ...rules
  };

  const fieldName = name ?? ('lastName' as Path<FormState>);

  return (
    <TextFieldWithControl
      {...props}
      control={control}
      name={fieldName}
      label={t('Last name')}
      autoComplete="family-name"
      rules={validationRules}
      required
    />
  );
};

export default LastNameField;
